import speakingurl from 'speakingurl'

export const SLUG_LIMIT = 100

export default {
  /** @param {import('vue').App} app - The Vue instance. */
  install (app) {
    app.mixin({
      methods: {
        $getSlug (stringToSlug) {
          const getSlug = speakingurl.createSlug({ truncate: SLUG_LIMIT })
          return getSlug(stringToSlug)
        },
      },
    })
  },
}
